import { Button, Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import * as React from "react";

import { useTl } from "../../hooks";
import { ETLCodes } from "../../locales/ETLCodes";
import { ICustomButtonProps } from "./ICustomButtonProps";

interface IImportButtonProps extends ICustomButtonProps {}

export const ImportButton: React.FunctionComponent<IImportButtonProps> = ({
  minimal = true,
  onClick,
  loading,
  disabled,
  intent = Intent.PRIMARY,
  text,
  hideText,
}) => {
  const { t } = useTl();
  return (
    <Button
      icon={IconNames.IMPORT}
      minimal={minimal}
      onClick={onClick}
      text={!hideText ? text || t(ETLCodes.Import) : null}
      intent={intent}
      loading={loading}
      disabled={disabled}
    />
  );
};
